<div class="groups-body">
  <coa-add-to-group-body-empty
    *ngIf="showEmpty$ | async"
    class="add-to-group-body-empty">
  </coa-add-to-group-body-empty>

  <coa-add-to-group-body-error
    *ngIf="showError$ | async"
    class="add-to-group-body-error">
  </coa-add-to-group-body-error>

  <coa-add-to-group-body-skeleton
    *ngIf="showSkeleton$ | async"
    class="add-to-group-body-skeleton">
  </coa-add-to-group-body-skeleton>

  <coa-add-to-group-body-list
    *ngIf="showList$ | async"
    [clientId]="clientId"
    [elements]="groups$ | async"
    [selections]="selections"
    class="add-to-group-body-list">
  </coa-add-to-group-body-list>

  <coa-add-to-group-body-create
    (showCreateGroup)="showCreateGroup.emit()">
  </coa-add-to-group-body-create>
</div>
